import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export const SpotHorizontalFields = ({ children, className, ...props }: PropsWithChildren<{ className?: string } & Record<string, unknown>>) => (
    <div className={classNames('spot-form__field-group spot-form__field-group--horizontal', className)} {...props}>
        {children}
    </div>
);
